package diana.soleil.design.iraniancanadienbazzar.core.data

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * Hidden Gems adult-tier kill switch, pushed from Remote Config (`gems_adult_jokes_enabled`,
 * default **false** in every environment — store-rating decision, `docs/HIDDEN_GEMS_PLAN.md` §3).
 * While OFF the adult tier is completely invisible: no toggle, no age gate, no adult queries.
 * A Developer Menu override lets QA exercise the gated flow without touching Remote Config
 * (same pattern as [SunsetConfig]); `null` override defers to the fetched value.
 */
class GemsConfig {
    private val remote = MutableStateFlow(false)
    private val debugOverride = MutableStateFlow<Boolean?>(null)

    private val _adultJokesEnabled = MutableStateFlow(false)
    val adultJokesEnabled: StateFlow<Boolean> = _adultJokesEnabled.asStateFlow()

    /** Push the fetched Remote Config value. */
    fun update(adultJokesEnabled: Boolean) {
        remote.value = adultJokesEnabled
        recompute()
    }

    /** Developer Menu override: true/false forces the tier; null returns to the Remote Config value. */
    fun setDebugOverride(enabled: Boolean?) {
        debugOverride.value = enabled
        recompute()
    }

    fun debugOverride(): Boolean? = debugOverride.value

    private fun recompute() {
        _adultJokesEnabled.value = debugOverride.value ?: remote.value
    }
}
